module.exports = {
    DEFAULT: {
        icon: 'odf-icon-time',
        text: '',
        style: 'default',
    },
    CHANGE_OF_AIRPORT: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeOfAirport',
        style: 'flight',
    },
    CHANGE_OF_TERMINAL: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeOfTerminal',
        style: 'flight',
    },
    CHANGE_OF_FLIGHT_CARRIER: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeOfFlightCarrier',
        style: 'flight',
    },
    CHANGE_TO_FLIGHT: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeToFlight',
        style: 'flight',
    },
    CHANGE_OF_TRAIN_STATION: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeOfTrainStation',
        style: 'train',
    },
    CHANGE_OF_TRAIN_CARRIER: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeOfTrainCarrier',
        style: 'train',
    },
    CHANGE_TO_TRAIN: {
        icon: 'odf-icon-man-baggage-walking',
        text: 'changeToTrain',
        style: 'train',
    },
};
